<template>
  <div>
    <div class="header">
      <h2>Rosters</h2>
      <router-link
        :to="{
          name: 'rosterCreate',
          from: 'locker'
        }"
      >
        <button class="btn btn-dark btn-block btn-add">
          <span>Create roster</span><span class="plusIcon">&#65291;</span>
        </button>
      </router-link>
    </div>
    <div class="description">
      Create and save individual team rosters for use in current and future
      orders.
    </div>
    <BBDataTable
      class="rosterContainer"
      :columns="columns"
      :support-add-new="false"
      path-url-api="rosters"
      :default-api-params="{
        _fields: 'rosterName,status,createdAt',
        _sort: 'createdAt',
        _order: 'desc',
        _filter: [
          {
            field: 'isDeleted',
            op: '=',
            val: 'false'
          },
          {
            field: 'user',
            op: '=',
            val: userId
          }
        ]
      }"
    >
      <template v-slot:customButtons="slotProps">
        <button
          class="btn btn-link btn-highlight btn-sm d-flex align-items-center ml-1"
          @click="onDuplicateItem(slotProps.props.row._id)"
        >
          <font-awesome-icon class="mr-2" :icon="icons.cloneIcon" />
          <span class="bb-label">Duplicate</span>
        </button>
        <router-link
          :to="{
            name: 'rosterEdit',
            params: { edit: true, from: 'locker', id: slotProps.props.row._id }
          }"
          class="btn btn-link btn-highlight btn-sm d-flex align-items-center ml-1"
          v-if="slotProps.props.row"
        >
          <font-awesome-icon class="mr-2" :icon="icons.editIcon" />
          <span class="bb-label">EDIT</span>
        </router-link>
      </template>
    </BBDataTable>
  </div>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator'
import { faPencilAlt, faPlus, faClone } from '@fortawesome/free-solid-svg-icons'
import { namespace } from 'vuex-class'

const oauthStore = namespace('oauthStore')

@Component({
  components: {}
})
export default class Roster extends Vue {
  @oauthStore.Getter('userId') userId
  icons = {
    editIcon: faPencilAlt,
    plusIcon: faPlus,
    cloneIcon: faClone
  }

  get columns() {
    return [
      {
        label: 'ID',
        field: '_id',
        hidden: true
      },
      {
        label: 'Roster',
        field: 'rosterName',
        tdClass: 'boldText',
        filterOptions: {
          enabled: true, // enable filter for this column
          placeholder: 'Filter by Roster Name', // placeholder for filter input
          filterValue: '', // initial populated value for this filter
          operator: 'like',
          trigger: 'keyup' // only trigger on enter not on keyup
        }
      },
      {
        label: 'Created On',
        field: 'createdAt',
        type: 'date',
        dateInputFormat: 'YYYY-MM-DDTHH:mm:ss.SSS', // expects 2018-03-16T05:29:18.123
        dateOutputFormat: 'MM/DD/YYYY'
      },
      {
        label: 'Actions',
        field: 'actions',
        hasDeleteButton: true
      }
    ]
  }

  onDuplicateItem() {
    console.log('duplicate')
  }
}
</script>

<style lang="scss" scoped></style>
